import { render, staticRenderFns } from "./SystemInfoPage.vue?vue&type=template&id=31c58444&"
import script from "./SystemInfoPage.vue?vue&type=script&lang=js&"
export * from "./SystemInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports